export default {
  SET_MODAL(state, modal) {
    state.modal = modal
  },
  SET_MODAL_MINI(state, modal) {
    state.modalMini = modal
  },

  SET_CURRENT_USER_CALL(state, data) {
    state.currentUserCall = data
  },
  SET_TMP_CURRENT_USER_CALL(state, data) {
    state.tmpCurrentCallUser = data
  },
  SET_VUEX_CALL_STATUS(state, data) {
    state.vuexCallStatus = data
  },
  SET_MODAL_CLOSE_CALLBACK(state, callback) {
    state.onModalCloseCallback = callback
  },
  SET_CALLIO_RESULT_OPTIONS(state, options) {
    state.callioResultOptions = options
  },
}
